enum EnumLogLevel {
	Debug = 0,
	Trace = 1,
	Info = 2,
	Warn = 3,
	Error = 4
}
export default EnumLogLevel
